/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as PermissionService} from "../../../Services/PermissionService";
import autobind from "autobind-decorator";
import {FormCheck} from "react-bootstrap";
import React from "react";

export class UserPermissionFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props);

		this.setInitialState({
			permission: null
		});
	}

	componentDidMount() {
		PermissionService.GetPermission(this.props.Value)
			.then((x) => {
				this.setState({permission: x.result});
			});
	}

	@autobind
	_render() {
		return <FormCheck
			type="checkbox"
			id={'permission' + this.state.permission?.permissionId}
			label={this.state.permission?.name}
			style={{margin: 0}}
			checked={this.props.Data.value}
			onChange={(x) => {
				if (this.props.Data.value) {
					this.props.OnUpdate(null);
				} else {
					this.props.OnUpdate(this.state.permission.permissionId);
				}
			}}
		/>;
	}
}